import * as React from 'react';
import { useContext } from 'react';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import ExitButton from 'bundles/grading/components/common/ExitButton';
import { AutoSaveContext } from 'bundles/grading/components/staff-graded-assignments/auto-save/utils';

import _t from 'i18n!nls/grading';

type Props = {
  routeOnClose: PatchedLocationDescriptor;
};

// Exit button for specifically for SGAs
const SGAExitButton = ({ routeOnClose }: Props) => {
  const { isSaving, isSubmitting, hasUnsavedChanges } = useContext(AutoSaveContext);
  const stay = isSaving || isSubmitting || hasUnsavedChanges;
  return (
    <ExitButton
      routeOnClose={routeOnClose}
      tooltipMessage={stay ? _t('Saving, please wait') : undefined}
      disabled={hasUnsavedChanges}
    />
  );
};

export default SGAExitButton;
